// © Microsoft Corporation. All rights reserved.

import { MarketSelectorOptionDirection, MarketSelectorOptionProps, MarketSelectorProps } from "./Interfaces";

import { MarketSelector as MarketSelectorBase } from "./MarketSelector";
import { customElement } from "@microsoft/fast-element";
import { MarketSelectorStyles as styles } from "./MarketSelector.styles";
import { MarketSelectorTemplate as template } from "./MarketSelector.template";

/**
 * Microsoft News market selector web component
 */
@customElement({
    name: "msn-market-selector",
    template,
    styles
})
class MsnMarketSelector extends MarketSelectorBase { }

export {
    MsnMarketSelector,
    MarketSelectorOptionDirection,
    MarketSelectorOptionProps,
    MarketSelectorProps as MsnMarketSelectorProps
};
